<div class="mb-3">
  <div class="section-header-blue">
    <i class="bx bx-clinic"></i> Encuentro Clínico
    @let claseBadge = getClaseBadge(encounter().clase.codigo);
    @let statusBadge = getStatusBadge(encounter().status);
    <span class="badge {{ claseBadge.color }} ms-2">{{ claseBadge.label }}</span>
    <span class="badge {{ statusBadge.color }} ms-1">{{ statusBadge.label }}</span>
  </div>
  <div class="section-body">
    <div class="row g-2">
      <div class="col-md-6">
        @if (encounter().identificador) {
          <p class="mb-2"><strong>N° Encuentro:</strong> {{ encounter().identificador }}</p>
        }
        <p class="mb-2">
          <strong>Fecha de Ingreso:</strong> {{ formatDate(encounter().periodo.inicio) || '—' }}
        </p>
        @if (encounter().periodo.fin) {
          <p class="mb-2">
            <strong>Fecha de Egreso:</strong> {{ formatDate(encounter().periodo.fin) }}
          </p>
        }
        @if (encounter().motivos.length > 0) {
          <p class="mb-2">
            <strong>Causa Externa / Motivo:</strong><br />
            @for (motivo of encounter().motivos; track $index) {
              <span class="badge bg-secondary mt-1">
                {{ motivo.display || motivo.text || motivo.codigo }}
              </span>
            }
          </p>
        }
        @if (encounter().prestador) {
          <p class="mb-2"><strong>Prestador:</strong> {{ encounter().prestador }}</p>
        }
      </div>
      <div class="col-md-6">
        @if (encounter().tipos.length > 0) {
          @for (tipo of encounter().tipos; track $index) {
            @if (tipo.display && tipo.display.toLowerCase().includes('modalidad')) {
              <p class="mb-2">
                <strong>Modalidad:</strong> {{ tipo.display.replace('Modalidad:', '').trim() }}
              </p>
            }
            @if (tipo.display && tipo.display.toLowerCase().includes('grupo')) {
              <p class="mb-2">
                <strong>Grupo de Servicio:</strong>
                {{ tipo.display.replace('Grupo de Servicio:', '').trim() }}
              </p>
            }
            @if (
              tipo.display &&
              tipo.display.toLowerCase().includes('tipo') &&
              !tipo.display.toLowerCase().includes('modalidad') &&
              !tipo.display.toLowerCase().includes('grupo')
            ) {
              <p class="mb-2">
                <strong>Tipo:</strong> {{ tipo.display.replace('Tipo:', '').trim() }}
              </p>
            }
          }
        }
        @if (encounter().clase.display) {
          <p class="mb-2"><strong>Entorno de Atención:</strong> {{ encounter().clase.display }}</p>
        }
      </div>
    </div>

    @if (encounter().diagnosticos.length > 0) {
      <hr />
      <p class="mb-2"><strong>Diagnósticos del Encuentro:</strong></p>
      <div class="table-responsive">
        <table class="table table-sm table-bordered mb-0">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Rol diagnóstico</th>
              <th>Tipo</th>
            </tr>
          </thead>
          <tbody>
            @for (dx of encounter().diagnosticos; track $index) {
              <tr>
                <td>{{ $index + 1 }}</td>
                <td>{{ dx.rol || '—' }}</td>
                <td>
                  @if (dx.tipoDx) {
                    <span class="badge bg-success">{{ dx.tipoDx }}</span>
                  } @else {
                    <span class="text-muted">—</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
<hr />
